var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11.209,
  height: 11.982,
  fill: "none",
  viewBox: "0 0 15 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.652,
  cy: 1.914,
  r: 1.181,
  stroke: "#77777A",
  strokeWidth: 0.934
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.652,
  cy: 9.934,
  r: 1.181,
  stroke: "#77777A",
  strokeWidth: 0.934
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 1.814,
  cy: 5.978,
  r: 1.181,
  stroke: "#77777A",
  strokeWidth: 0.934
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77777A",
  strokeWidth: 0.934,
  d: "m7.319 2.603-4.2 2.791M7.317 9.197 2.954 6.704"
})));
export { SvgShare as ReactComponent };
export default "/_next/static/images/share.svg";